import { Component, Input } from '@angular/core';


@Component({
    selector: 'app-icon',
    templateUrl: './icon.component.html',
    styleUrls: ['./icon.component.scss'],
})
export class IconComponent {

  @Input() svgIcon?: string;
  @Input() class?: string;

  @Input() badge?: string;
  @Input() badgeHidden: boolean = false;
  @Input() isFlexBox: boolean = true;

  constructor() {
  }

}
